import React, { Fragment,useEffect,useState } from "react";
import { Title } from "./outlet.styles";
import {
  blue300,
  black700,
  borderLight,
  black600,
  green100,
} from "../../../theme/colors";
import { xsBold } from "../../../theme/typeface";
import styled from "styled-components";
import moment from "moment";
import {triggerSimpleAjax} from "../../../helpers/httpHelper";
import {GET_OUTLETS_DETAILS, GET_QC_HISTORY} from "../../../helpers/constants/apiUrl";
import themeSizes from "../../../theme/themeSizes";

const UserInititals = styled.span`
  width: 40px;
  height: 40px;
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  color: #1e293b;
  background: ${(props) => props.bgColor || "rgba(91, 127, 220, 0.15)"};
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 2px;
`;

const RowWrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: ${black600};
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f8fafc;
  }

  > div {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    flex: 1;
    min-width: 0;

    p {
      margin: 0;
      font-size: 14px;
      line-height: 1.6;
      color: #334155;
      font-weight: 400;
      word-break: break-word;
      overflow-wrap: anywhere;
      white-space: pre-wrap;
    }
  }

  /* Date paragraph */
  > p {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    text-align: right;
    white-space: nowrap;
    margin-left: 16px;
    flex-shrink: 0;
    margin-top: 4px;
  }

  @media ${themeSizes.tablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px;

    > div {
      width: 100%;
      
      p {
        font-size: 13.5px;
      }
    }

    > p {
      width: 100%;
      text-align: left;
      margin-left: 54px;
      margin-top: 0;
      color: #94a3b8;
    }
  }
`;

const bgColor = ["rgba(226, 58, 58, 0.15)", "rgba(91, 127, 220, 0.15)", "rgba(34, 197, 94, 0.15)"];

export const QCEditHistory = ({ logs, state,related_workflow_object}) => {
  const [qResponse, setQResponse] = useState({})
console.log("state1",state)
console.log("state2",state?.outletDetails?.related_workflow_object)
  function refresh_qc_data () {
    triggerSimpleAjax(
      `${GET_QC_HISTORY}${state?.outletDetails?.related_workflow_object?.id}`,
      'GET',
      {},
      (response) => {
       setQResponse(response)
        // window.location.reload()
      },
      (err) => {
        console.log(err)
      },
    )
  }
  useEffect(() => {
    refresh_qc_data();
  }, []);
  useEffect(() => {
  }, [qResponse]);
  return (
    <Fragment>
      <Title titleColor={blue300} titleFontWeight={xsBold}>
        Qc Edit History
      </Title>
      {(qResponse?.data || []).length ? (
        qResponse?.data.map((log, index) => {
          const letters = log.message.slice(0, 2);
          const upadateDateAndTime = log.created
            ? moment(log.created).format("DD-MMM-YYYY hh:mm").split(" ")
            : "";
          return (
            <RowWrapper key={`${index}-${letters}`}>
              <div>
                <UserInititals bgColor={bgColor[index % bgColor.length]}>
                  {letters.toUpperCase()}
                </UserInititals>
                <p>{(log.message||"").replace(/_/g,' ')}</p>
              </div>
              <p>
                {upadateDateAndTime[0]} | {upadateDateAndTime.slice(1)}
              </p>
            </RowWrapper>
          );
        })
      ) : (
        <p>No Data Available</p>
      )}
    </Fragment>
  );
};
